/**
 * EOTD Luxury Animations
 * Smooth scroll-triggered animations for premium feel
 */

(function() {
  'use strict';

  // Intersection Observer for scroll animations
  const initScrollAnimations = () => {
    if (!('IntersectionObserver' in window)) {
      // Fallback: show all elements immediately
      document.querySelectorAll('.animate-on-scroll, .image-reveal, .stagger-children, [data-animate]').forEach(el => {
        el.classList.add('is-visible');
      });
      return;
    }

    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -60px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all animated elements
    const animatedElements = document.querySelectorAll(
      '.animate-on-scroll, .image-reveal, .stagger-children, [data-animate]'
    );
    animatedElements.forEach(el => observer.observe(el));
  };

  // Smooth parallax effect for images
  const initParallax = () => {
    const parallaxElements = document.querySelectorAll('[data-parallax]');
    if (!parallaxElements.length) return;

    let ticking = false;

    const updateParallax = () => {
      parallaxElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const scrollPercent = (rect.top + rect.height) / (window.innerHeight + rect.height);
        const parallaxValue = (scrollPercent - 0.5) * 30;
        el.style.transform = `translateY(${parallaxValue}px)`;
      });
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  };

  // Magnetic button effect
  const initMagneticButtons = () => {
    const buttons = document.querySelectorAll('.button-magnetic');

    buttons.forEach(button => {
      button.addEventListener('mousemove', (e) => {
        const rect = button.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        button.style.transform = `translate(${x * 0.15}px, ${y * 0.15}px)`;
      });

      button.addEventListener('mouseleave', () => {
        button.style.transform = 'translate(0, 0)';
      });
    });
  };

  // Smooth reveal for text
  const initTextReveal = () => {
    const textElements = document.querySelectorAll('[data-text-reveal]');

    textElements.forEach(el => {
      const text = el.textContent;
      el.innerHTML = '';

      text.split('').forEach((char, i) => {
        const span = document.createElement('span');
        span.textContent = char === ' ' ? '\u00A0' : char;
        span.style.animationDelay = `${i * 0.03}s`;
        span.classList.add('char-reveal');
        el.appendChild(span);
      });
    });
  };

  // Counter animation for numbers
  const initCounters = () => {
    const counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = parseInt(entry.target.dataset.counter);
          const duration = 2000;
          const start = 0;
          const startTime = performance.now();

          const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeOut = 1 - Math.pow(1 - progress, 3);
            const current = Math.round(start + (target - start) * easeOut);

            entry.target.textContent = current;

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          };

          requestAnimationFrame(animate);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(counter => observer.observe(counter));
  };

  // Cursor follower for featured guides
  const initCursorFollower = () => {
    const cards = document.querySelectorAll('.featured-guides__card');

    cards.forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        card.style.setProperty('--mouse-x', `${x}%`);
        card.style.setProperty('--mouse-y', `${y}%`);
      });
    });
  };

  // Initialize all animations
  const init = () => {
    initScrollAnimations();
    initParallax();
    initMagneticButtons();
    initCounters();
    initCursorFollower();
  };

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', init);
})();
